

import Module, { moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import Utility from "../../../../utility/utility";
import ModelData from "../../../public/model_data";
import PromiseUtility from "../../../../utility/promiseUtility";
import Q2TableView from "./q2_table_view";
import { Card, CardColor, CardNameIndex } from "./q2_card_common";
import { EffectType } from "./q2_table_view_base";
import Q2SeatAreaCards from "./q2_seat_area_cards";
import { SelectState } from "./q2_desk_area_cards_pattern";
import ModuleManager from "../../../../framework/core/module_manager";

const const_wan_codes = [10, 11, 12, 13, 14, 15, 16, 17, 18]
const const_tong_codes = [19, 20, 21, 22, 23, 24, 25, 26, 27]
const const_tiao_codes = [1, 2, 3, 4, 5, 6, 7, 8, 9]

const const_recycle_duration: number = 1
const const_recycle_interval: number = 0.1
const const_recycle_seat_interval: number = 0.133
const const_fapai_duration: number = 0.6
const const_fapai_single_interval: number = 0.1
const const_fapai_seat_interval: number = 0.1

const const_mopai_duration: number = 0.63
const const_discard_duraton: number = 1.3
const const_gold_fly_duration: number = 0.5

const { ccclass } = cc._decorator;

@ccclass
@moduleInit("Q2TestModule")
export default class Q2TestModule extends Module<Q2TableView, null>  {

    m_lastRefreshTime = 0    
    
    protected m_select_area: number = -1
    protected m_select_pattern_index: number = -1

    constructor() {
        super();
        this.viewType = Q2TableView
        this.modelType = null
        this.windowPrefabResPath = 'package/q2/q2_table'
    }

    onShow(arg){
        let self = this
        super.onShow(arg)
        this.view.buttonMask.node.on('click', this.on_click, this)
        self.eventBind('Q2SeatAreaCards_pattern_click', self.on_click_area_pattern)
        // this.testAdjustMyHandCards()  
    }

    protected on_click(btn: cc.Button){
        cc.log('on_click-----------', btn.name)
        if(btn.node == this.view.buttonMask.node){
            this.testShowHandCards()            
        }

    }

    protected on_click_area_pattern(areaCards: Q2SeatAreaCards, patternIndex: number){
        let self = this
        let areaCardsList = this.view.seatAreaCardsList
        let lastSelectArea = self.m_select_area
        let lastSelectIndex = self.m_select_pattern_index        
        for (let index = 0; index < areaCardsList.length; index++) {
            const tmpAreaCards = areaCardsList[index];
            if(areaCards == tmpAreaCards){
                this.m_select_area = index
                this.m_select_pattern_index = patternIndex
                let lastArea = self.view.seatAreaCardsList[lastSelectArea]
                if(lastArea){
                    lastArea.setPatternState(lastSelectIndex, SelectState.Normal)
                    lastArea.refreshPatternSelectState()
                }
                
                let area = self.view.seatAreaCardsList[index]
                if(area){
                    area.setPatternState(patternIndex, SelectState.Selected)
                    area.refreshPatternSelectState()
                }
                return
            }
        }
    }

    protected getTargetCodes(codeList: number[], includeCodes: number[]){
        let list: number[] = []
        for (let index = 0; index < codeList.length; index++) {
            const code = codeList[index];
            for (let i = 0; i < includeCodes.length; i++) {
                const includeCode = includeCodes[i];
                if(code == includeCode){
                    list.push(code)
                    break
                }
            }
        }
        return list
    }

    protected isWan(code: number){
        return code >= 10 && code <= 18
    }

    protected isTong(code: number){
        return code >= 19 && code <= 27
    }

    protected isTiao(code: number){
        return code >= 1 && code <= 9
    }

    protected test_dispatch(localPos: number){
        let self = this
        let code = 1
        let codeList = [
            1, 2, 3, 4
        ]

    }

    @bindButtonClickEvent('openBtn')
    protected on_click_open_card_btn(node: cc.Node){
        this.view.playBtnClickAnim(node)     
    }

    protected getComingCode(codeList: number[]): number{
        if(codeList.length % 3 == 2){
            return codeList[codeList.length - 1]
        }
        return -1
    }

    @bindButtonClickEvent('storageBtn')
    protected on_click_storage_btn(node: cc.Node){
        let self = this
        let codeList = []
        let handCodeList = []
        let selectedCardsData = self.view.mySeatCards.getSelectedPokers()
        for (let index = 0; index < selectedCardsData.real_selected_codeList.length; index++) {
            let code = selectedCardsData.real_selected_codeList[index];
            code = Card.fullCodeToCode(code)
            codeList.push(code)
            handCodeList.push(code)
        }
        if(!self.canStorage(handCodeList)){
            ModuleManager.instance.toast('未满足下牌条件')            
        }else{
            ModuleManager.instance.toast('满足下牌条件')            
        }
    }

    @bindButtonClickEvent('raiseBtn')
    protected on_click_raise_btn(node: cc.Node){

    }

    @bindButtonClickEvent('attachBtn')
    protected on_click_attach_btn(node: cc.Node){
    }


    protected canRaise(commonCards: number[], handCards: number[]): boolean{
        if(!commonCards || commonCards.length == 0 || !handCards || handCards.length == 0){
            return false
        }
        let codeList = commonCards.concat(handCards)        
        return this.isSameIndex(codeList) || this.isSameColorSequence(codeList)
    }

    protected canStorage(handCards: number[]): boolean{                
        return this.isSameIndex(handCards) || this.isSameColorSequence(handCards)
    }

    protected canAttach(areaCards: number[], handCard: number): boolean{
        if(!areaCards || areaCards.length < 3 || !handCard){
            return false
        }
        let codeList = areaCards.concat([handCard])
        return this.isSameIndex(codeList) || this.isSameColorSequence(codeList)
    }

    protected isSameColorSequence(codeList: number[]){
        if(!codeList || codeList.length < 3 || codeList.length > 13){
            return false
        }
        let cardList: Card[] = []
        let color = null
        for (let index = 0; index < codeList.length; index++) {
            const code = codeList[index];
            let card = Card.makeCardByCode(code)
            if(color && color != card.color){
                return false
            }
            color = card.color
            cardList.push(card)
        }
        cardList.sort(function(a, b){
            return a.index - b.index
        })
        let firstIndex = 0
        let isSequence = true
        for (let i = 0; i < cardList.length; i++) {
            const card = cardList[i];
            if(firstIndex && card.index != firstIndex + i){
                isSequence = false
                break
            }
            if(!firstIndex){
                firstIndex = card.index
            }
        }
        if(isSequence){
            return true
        }
        cardList.sort(function(a, b){
            return a.logicIndex - b.logicIndex
        })

        let firstLogicIndex = 0
        for (let i = 0; i < cardList.length; i++) {
            const card = cardList[i];
            if(firstLogicIndex && card.logicIndex != firstLogicIndex + i){
                return false
            }
            if(!firstLogicIndex){
                firstLogicIndex = card.logicIndex
            }
        }
        return true
    }

    protected isSameIndex(codeList: number[]){
        if(!codeList || codeList.length < 3 || codeList.length > 4){
            return false
        }
        let firstIndex = 0
        for (let i = 0; i < codeList.length; i++) {
            const code = codeList[i];
            let index = Card.codeToIndex(code)
            if(firstIndex && firstIndex != index){
                return false
            }
            firstIndex = index
        }
        return true
    }

    protected testAdjustMyHandCards(){
        let self = this
        let codeList = [                        
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_A),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_5),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_6),    
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_7),  
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_8),  
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_9),  
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_10),  
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_J),  
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_Q),  
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_K),  
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_K),  
            Card.colorIndexToCode(CardColor.color_plum, CardNameIndex.card_K),  
            
            // Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),
            // Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),
            // Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),
            // Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_A),
            // Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),
            // Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6),    

            // Card.colorIndexToCode(CardColor.color_plum, CardNameIndex.card_2),
            // Card.colorIndexToCode(CardColor.color_plum, CardNameIndex.card_3),
            // Card.colorIndexToCode(CardColor.color_plum, CardNameIndex.card_4),
            // Card.colorIndexToCode(CardColor.color_plum, CardNameIndex.card_A),
            // Card.colorIndexToCode(CardColor.color_plum, CardNameIndex.card_5),
            // Card.colorIndexToCode(CardColor.color_plum, CardNameIndex.card_6),    

            // Card.colorIndexToCode(CardColor.color_square, CardNameIndex.card_2),
            // Card.colorIndexToCode(CardColor.color_square, CardNameIndex.card_3),
            // Card.colorIndexToCode(CardColor.color_square, CardNameIndex.card_4),
            // Card.colorIndexToCode(CardColor.color_square, CardNameIndex.card_A),
            // Card.colorIndexToCode(CardColor.color_square, CardNameIndex.card_5),
            // Card.colorIndexToCode(CardColor.color_square, CardNameIndex.card_6),    
        ]
        // self.view.mySeatCards.showPokers(true, codeList)
        self.view.mySeatCards.playFaPaiAnim(codeList)
        self.view.mySeatCards.setCustomOnFinishDragFunc(function(){
            let lastSelectData = self.view.mySeatCards.getSelectedPokers() 
            self.view.mySeatCards.refreshPokerSelectState(false)  
            let selectData = self.view.mySeatCards.getSelectedPokers()                
            // if(selectData.real_selected_codeList.length > 1){
            //     selectData.real_selected_pokerList.sort(function(a, b){
            //         return b.selected_time - a.selected_time
            //     })
            //     let selectCodes = [selectData.real_selected_pokerList[0].code]
            //     self.view.mySeatCards.selectPokers(selectCodes, null)
            //     self.view.mySeatCards.refreshPokerSelectState(false)                     
            // }
        })
        self.view.showStorageBtn(true)

        
        self.view.deskCards.playCardInAnim(codeList)
        let localPos = 1        
        self.view.showSeatHandCardsBg(localPos, true)
        self.view.showSeatHandCardsCount(localPos, true, 0)
        self.view.playSeatHandCardInAnim(localPos, codeList, function(){
            self.view.showSeatHandCardsCount(localPos, true, codeList.length)
        })
        // self.view.seatHandCardsList[0].playFaPaiAnim(codeList)
        // self.schedule(function(){
        //     let codeList = [
        //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
        //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
        //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
        //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_5),
        //     ]
        //     self.view.mySeatCards.playCardCommingAnim(codeList)
        // }, 1)
    }


    aIndex = 0
    bIndex = 0

    testQueue = []    
    protected testShowHandCards(){
        let self = this
        // self.view.setSeatCount(5)
        // self.view.resetSeatViewPos()
        
        let ismale = false
        if(this.testQueue.length == 0){            
            this.testQueue = [
                function(){
                    self.view.playLiuJuAnim()
                },
                function(){
                    self.view.showMask(true)
                    self.view.playCommonAnim(EffectType.PaiXing_HuPai, function(){
                        self.view.showMask(false)
                    })
                },
                // function(){
                //     self.view.showSeatClock(1, true, 10, null, null, null, 10)
                //     self.view.showSeatClock(2, true, 15, null, null, null, 15)
                // },

                // function(){
                //     let type = EffectType.DiuChengPai
                //     console.log(type)
                //     self.view.playAreaAnim(0, type)                    
                // },
                // function(){
                //     let type = EffectType.DiuDummy
                //     console.log(type)
                //     self.view.playAreaAnim(0, type)                    
                // },

                // function(){
                //     let codeList = [                        
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //         // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_A),
                //         // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_5),
                //         // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_6),    
                //         // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_7),  
                //         // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_8),  
                //         // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_9),  
                //         // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_10),  
                //         // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_J),  
                //         // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_Q),  
                //         // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_K),  
                //         // Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_K),  
                //         // Card.colorIndexToCode(CardColor.color_plum, CardNameIndex.card_K),  
                //     ]
                //     self.view.showQuickHuCards(true, codeList, [], [], codeList[0])
                // },

                // function(){
                //     self.view.showQuickHuCards(false)
                // }

                // function(){
                //     self.testAdjustMyHandCards()                    
                // },
                // function(){
                //     let handCards = self.view.mySeatCards.getCodeList()
                //     let deskCards = self.view.deskCards.getCodeList()
                //     let codeList1 = []
                //     let codeList2 = []
                //     for (let index = 0; index < 1; index++) {
                //         codeList1.push(handCards[index])
                //         codeList2.push(deskCards[index])
                //     }
                    
                //     // self.view.mySeatCards.playCardOutAnim(codeList1)    
                //     self.view.mySeatCards.resetPokers()                
                //     self.view.mySeatCards.playCardInAnim(codeList2)

                //     // self.view.deskCards.playCardOutAnim(codeList2)
                //     self.view.deskCards.playCardInAnim(codeList1)

                //     let localPos = 1        
                //     self.view.showSeatHandCardsBg(localPos, true)
                //     self.view.playSeatHandCardOutAnim(localPos, codeList2)
                //     self.view.playSeatHandCardInAnim(localPos, codeList1)
                    
                // },
                // function(){
                //     self.view.showAreaCards(0, true, [
                //         [
                //             Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //             Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //             Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //         ],
                //         [
                //             Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_5),
                //             Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_6),
                //             Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_7),
                //         ],
                //         [
                //             Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_8),
                //             Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_9),
                //             Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_10),
                //         ],
                //         [
                //             Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_8),
                //             Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_9),
                //             Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_10),
                //         ],
                //     ])
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_7),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_7),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_7),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 0, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                //     self.view.playAreaCardsInAnim(0, 1, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                //     self.view.playAreaCardsInAnim(0, 2, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                //     self.view.playAreaCardsInAnim(0, 3, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                //     self.view.playAreaCardsInAnim(0, 4, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                //     self.view.playAreaCardsInAnim(0, 5, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_7),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_7),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_7),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 0, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                //     self.view.playAreaCardsInAnim(0, 1, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                //     self.view.playAreaCardsInAnim(0, 2, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                //     self.view.playAreaCardsInAnim(0, 3, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                //     self.view.playAreaCardsInAnim(0, 4, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                //     self.view.playAreaCardsInAnim(0, 5, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_7),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_7),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_7),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 0, codeList, null, {codeList: codeList, type: 1, fromCompleteProcess: true})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 3, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 4, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 5, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 6, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 7, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 8, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 9, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 10, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 11, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 12, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 13, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 14, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //     ]
                //     self.view.playAreaCardsInAnim(0, 15, codeList, null, {codeList: codeList, type: 1})
                // },
                // function(){
                //     let areaCards = self.view.seatAreaCardsList[0]
                //     self.m_select_area = 0
                //     self.m_select_pattern_index = 1
                //     areaCards.setState([0, 2], [1], null)
                //     areaCards.refreshPatternSelectState()
                // },
                // function(){
                //     let areaCards = self.view.seatAreaCardsList[0]
                //     self.m_select_area = -1
                //     self.m_select_pattern_index = -1
                //     areaCards.setState([], null, null)
                //     areaCards.refreshPatternSelectState()
                // },
                // function(){
                //     let codeList = [                        
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_A), 
                //     ]
                //     let disableCodeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_5),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_6),    
                        
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_A),
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),
                //     ]
                //     self.view.mySeatCards.enablePokers(codeList)
                //     self.view.mySeatCards.refreshPokerDisableState()

                //     // self.view.mySeatCards.selectPokers(codeList, null)
                //     // self.view.mySeatCards.refreshPokerSelectState(false)
                    
                    
                // },
                // function(){
                //     self.view.mySeatCards.resetPokers()
                // },
                // function(){
                //     let codeList = [
                //         0,
                //         0,
                //         0,
                //         0,
                //         0,
                //     ]
                //     self.view.seatHandCardsList[1].showPokers(true, codeList)
                // },
                // function(){
                //     let codeList = [
                //         0,
                //         0,
                //     ]
                //     self.view.seatHandCardsList[1].playCardInAnim(codeList)
                // },
                // function(){
                //     let codeList = [
                //         0,
                //         0,
                //     ]
                //     self.view.seatHandCardsList[1].playCardOutAnim(codeList)
                // },
                // function(){
                //     let codeList = [
                //         0,                        
                //     ]
                //     self.view.seatHandCardsList[1].playCardOutAnim(codeList)
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),              
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6),  
                //     ]
                //     self.view.deskCards.playCardInAnim(codeList)
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),              
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6),         
                //     ]
                //     self.view.deskCards.playCardInAnim(codeList)
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),              
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6),         
                //     ]
                //     self.view.deskCards.playCardInAnim(codeList)
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),              
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6),       
                //     ]
                //     self.view.deskCards.playCardInAnim(codeList)
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),              
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6),     
                //     ]
                //     self.view.deskCards.playCardInAnim(codeList)
                // },

                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),              
                //     ]
                //     self.view.deskCards.playCardOutAnim(codeList)
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),              
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6),            
                //     ]
                //     self.view.deskCards.playCardOutAnim(codeList)
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),              
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6),          
                //     ]
                //     self.view.deskCards.playCardOutAnim(codeList)
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),              
                //     ]
                //     self.view.deskCards.playCardOutAnim(codeList)
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),              
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),  
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6), 
                //     ]
                //     self.view.deskCards.playCardOutAnim(codeList)
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),              
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),              
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6),              
                //     ]
                //     self.view.seatAreaCardsList[0].playCardInAnim(0, codeList)
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_7),           
                //     ]
                //     self.view.seatAreaCardsList[0].playCardInAnim(0, codeList)                    
                // },
                // function(){
                //     self.view.seatAreaCardsList[0].setState([], [])
                //     self.view.seatAreaCardsList[0].refreshPatternSelectState()    
                // },
                // function(){
                //     self.view.seatAreaCardsList[0].setState([], [0])
                //     self.view.seatAreaCardsList[0].refreshPatternSelectState()
                // },
                // function(){
                //     self.view.seatAreaCardsList[0].setState([0], [])
                //     self.view.seatAreaCardsList[0].refreshPatternSelectState()
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),              
                //     ]
                //     self.view.seatAreaCardsList[0].playCardInAnim(0, codeList)
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_8),             
                //     ]
                //     self.view.seatAreaCardsList[0].playCardInAnim(0, codeList)
                // },

                // function(){                    
                //     if(self.aIndex > EffectType.ZhaDan){
                //         self.aIndex = 0
                //     }
                //     let index = self.aIndex
                //     self.view.playAreaAnim(0, index)
                //     self.aIndex++
                // },
            ]            
        }
        let testFun = this.testQueue.shift()
        testFun()

        
    }
}